// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: '99a375e5-652b-4b9e-9cb4-0e0369a512a2',
      type: 'Container',
      runtimeType: null,
      name: 'measureTape',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '0e99c5ee-dd5c-4392-bcb6-3926c2e90044',
      type: 'Sprite',
      runtimeType: null,
      name: 'bladeMask',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Measure_Tape_Mask',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '1e0914c5-02cd-4636-a513-9325ac7a9793',
      type: 'Sprite',
      runtimeType: null,
      name: 'innerBladeMask',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.68
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Measure_Tape_Case_Mask',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '07e98ade-a513-49be-98dd-28359eca2000',
      type: 'Sprite',
      runtimeType: null,
      name: 'case',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Measure_Tape_Case',
      parent: '99a375e5-652b-4b9e-9cb4-0e0369a512a2',
      data: undefined,
      stateByName: {
        hook: {
          visible: false
        },
        blade: {
          visible: false
        },
        blade_to_hook: {
          visible: false
        },
        hook_to_case: {
          visible: false
        },
      }
    },
    {
      id: '4f036549-57da-452c-a514-ce21751d76b3',
      type: 'Sprite',
      runtimeType: null,
      name: 'blade',
      className: '',
      x: 0,
      y: 38,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Measure_Tape_Blade',
      parent: '99a375e5-652b-4b9e-9cb4-0e0369a512a2',
      data: undefined,
      stateByName: {
        hook: {
          x: 0,
          y: -351
        },
        blade: {
          x: 0,
          y: -62
        },
        case: {
          y: 9
        },
        case_only: {
          y: -332
        },
        blade_to_hook: {
          x: 0,
          y: -179
        },
        case_to_hook: {
          y: -252
        },
        hook_to_case: {
          x: 0,
          y: -351
        },
      }
    },
    {
      id: '20594454-73d1-4a5f-a9aa-18dc24f60857',
      type: 'Sprite',
      runtimeType: null,
      name: 'stopShadow',
      className: '',
      x: 0,
      y: 38,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Measure_Tape_Stop_Shadow',
      parent: '99a375e5-652b-4b9e-9cb4-0e0369a512a2',
      data: undefined,
      stateByName: {
        hook: {
          visible: false
        },
        blade: {
          visible: false
        },
        case_only: {
          visible: false
        },
        blade_to_hook: {
          visible: false
        },
        hook_to_case: {
          visible: false
        },
      }
    },
    {
      id: 'c030282e-022e-4b1a-99b3-3c43f148ff3d',
      type: 'Sprite',
      runtimeType: null,
      name: 'thumb_lock',
      className: '',
      x: 0,
      y: -12,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Measure_Tape_Thumb_Lock',
      parent: '99a375e5-652b-4b9e-9cb4-0e0369a512a2',
      data: undefined,
      stateByName: {
        hook: {
          visible: false
        },
        blade: {
          visible: false
        },
        blade_to_hook: {
          visible: false
        },
        hook_to_case: {
          visible: false
        },
      }
    }
  ],
  version: '1.0.0',
  stateNames: [
    'case',
    'hook',
    'blade',
    'case_only',
    'blade_to_hook',
    'case_to_hook',
    'hook_to_case'
  ],
  animations: []
} as const;

export class MeasureTapeBlockerLayout {
  static raw = raw;
  root: Container;
  measureTape: Container;
  bladeMask: Sprite;
  innerBladeMask: Sprite;
  case: Sprite;
  blade: Sprite;
  stopShadow: Sprite;
  thumb_lock: Sprite;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: 'case' | 'hook' | 'blade' | 'case_only' | 'blade_to_hook' | 'case_to_hook', 'hook_to_case';
    ModelByName: {
      root: typeof raw['list'][0];
      measureTape: typeof raw['list'][1];
      bladeMask: typeof raw['list'][2];
      innerBladeMask: typeof raw['list'][3];
      case: typeof raw['list'][4];
      blade: typeof raw['list'][5];
      stopShadow: typeof raw['list'][6];
      thumb_lock: typeof raw['list'][7];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
